module.exports = __webpack_public_path__ + "img/card-bg-small.3441ed2.png";